import React from 'react'
import { Trip } from '../../types'
import { FaStar } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import Cookies from 'js-cookie'
import { PiHeartFill, PiHeartDuotone } from 'react-icons/pi'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFavorites, addFavorite, deleteFavorite } from '../../features/home/favSlice'
import { AppDispatch, RootState } from '../../store'
import { useTranslation } from 'react-i18next'

const AltTripCard = ({ trip }: { trip: Trip }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch<AppDispatch>();
    const { favorites } = useSelector((state: RootState) => state.favoriteslice);
    const ended = new Date() > new Date(trip.toDate); // ✅ عدلتها من fromDate لـ toDate
    const userId = Cookies.get('userId');

    const favoriteItem = favorites?.trips?.find(
        (fav: any) => fav?.type === "Trip" && fav?.trip?.id === trip.id
    );
    const isFavorite = Boolean(favoriteItem);

    const handleAddToFavorite = async () => {
        if (!userId) return alert("User not logged in");

        await dispatch(addFavorite({
            itemId: trip.id,
            userId,
            type: "Trip",
        }));

        dispatch(fetchFavorites({ id: userId }));
    };

    const handleRemoveFromFavorite = () => {
        if (!userId || !favoriteItem) return;

        dispatch(deleteFavorite({
            itemId: trip.id,
            userId,
            type: "Trip"
        }));
        dispatch(fetchFavorites({ id: userId }));
    };

    return (
        <Link to={`/trips/${trip.id}`} className={`relative group h-full rounded-lg overflow-hidden shadow-md transition hover:shadow-lg `}>

            <div className="aspect-[4/3] w-full overflow-hidden relative">
                <img
                    className={`w-full h-full object-cover transition group-hover:scale-105 ${ended ? "grayscale" : ""}`}
                    src={trip.tripImages[0]?.url}
                    alt="trip"
                    loading="lazy"
                />

                {ended && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <span className="text-white font-bold text-lg bg-red-600 px-3 py-1 rounded-lg shadow-lg">
                            {t("trip-ended") || "انتهت الرحلة"}
                        </span>
                    </div>
                )}
            </div>

            <div className="p-3 h-full flex flex-col gap-2 relative z-10 bg-grayColor">
                <div className="flex justify-between items-start">
                    <h3 className="font-semibold text-lg text-nowrap">{trip?.fromLocation} - {trip?.toLocation}</h3>
                    <p className="flex items-center gap-1 text-secondry">
                        <FaStar className="text-sm" />
                        <span>{trip?.rate != null ? (trip.rate % 1 === 0 ? trip.rate : trip.rate.toFixed(1)) : '--'}{' '}</span>
                    </p>
                </div>

                <p className="text-sm text-textSecond line-clamp-2 min-h-[40px]">{trip.details}</p>

                <div className="flex justify-between items-center pt-2 border-t border-textSecond border-dashed">
                    <p className="font-semibold text-secondry">{trip.price} {trip.currencyCode}</p>

                </div>
            </div>
            <div className="flex justify-between items-center mt-auto absolute w-full px-3 py-2 top-1 left-0">
                {trip?.subCategory?.title &&
                    <p className="text-xs bg-primary text-white px-2 py-1 rounded">{trip?.subCategory?.title}</p>}
                {userId ? isFavorite ?
                    (<button
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleRemoveFromFavorite(); }}
                        className="text-red-600 text-lg hover:opacity-80 transition" >
                        <PiHeartFill />
                    </button>)
                    :
                    (<button
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleAddToFavorite(); }}
                        className="text-white text-lg hover:text-red-500 transition" >
                        <PiHeartDuotone />
                    </button>)
                    : ""}
            </div>

        </Link>
    )
}

export default AltTripCard
